import React, { useState, useContext } from 'react'

import { Modal } from '../../UI/Modal'
import { ModalTitle } from '../../UI/ModalTitle'
import { ModalButton } from '../../UI/ModalButton'
import { ModalContent } from '../../UI/ModalContent'
import { ModalButtons } from '../../UI/ModalButtons'

import { useEndConversationModalContext } from './context'
import { useFeedbackModalContext } from '../FeedbackModal/context'

import { getFeedbackFormConfigApi } from '../../api/feedbackFormApi'
import {WebSocketsSharedContext} from '../../integrations/WebSockets'

export const EndConversationModal = props => {
  const [isLoading, setIsLoading] = useState(false)
  const { setIsOpenEndConversationModal } = useEndConversationModalContext()
  const { setIsOpenFeedbackModal, setFeedbackConfigs } =
    useFeedbackModalContext()
  const { handleResetChat } = useContext(WebSocketsSharedContext)

  const onSubmit = async() => {
    setIsLoading(true)
    await getFeedbackFormConfigApi(props.botId, props.chatId)
      .then(response => {
        if (response.status === 200) {
          return response.json()
        }
        handleResetChat()
      })
      .then(response => {
        response.postAction = 'CLOSE_WIDGET'
        setFeedbackConfigs(response)
        setIsOpenFeedbackModal(true)
      })
      .catch(error => {
        handleResetChat()
        console.log(error)
      })
    setIsLoading(false)

    setIsOpenEndConversationModal(false)
  }

  const onClose = () => {
    setIsOpenEndConversationModal(false)
  }

  const config = {
    'es': {
      title: '¿Está seguro de finalizar la conversación?',
      content: 'Toda la historia de comunicación con el chatbot se eliminará de forma permanente',
      cancel: 'Cancelar',
      endConversation: 'Finalizar conversación',
    },
    'en': {
      title: 'Are you sure you want to end the conversation?',
      content: 'All your chatbot history will be deleted permanently?',
      cancel: 'Cancel',
      endConversation: 'End Conversation',
    }
  }

  return (
    <Modal isLoading={isLoading}>
      <ModalTitle>{config[props.language ? props.language : 'en'].title}</ModalTitle>
      <ModalContent>{config[props.language ? props.language : 'en'].content}</ModalContent>
      <ModalButtons>
        <ModalButton variant="cancel" onClick={onClose}>
          {config[props.language ? props.language : 'en'].cancel}
        </ModalButton>
        <ModalButton variant="attention" onClick={onSubmit}>
          {config[props.language ? props.language : 'en'].endConversation}
        </ModalButton>
      </ModalButtons>
    </Modal>
  )
}
